import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { SuggestionFeedResult, SuggestionsProvider } from '@trovata/app/features/trovata-ai/suggestions/services/suggestions-provider';
import { WorkEvent } from '@trovata/app/features/trovata-ai/suggestions/models/suggestion-card.model';
import { DEFAULT_TTL_SECONDS } from '@trovata/app/features/trovata-ai/suggestions/utils/parse-suggestions';

/**
 * CashSuggestionsProvider — the Cash implementation of {@link SuggestionsProvider}.
 *
 * Cash has NO suggestion rules in v1, so this returns an empty feed
 * SYNCHRONOUSLY with no network call. That is the Cash-isolation guarantee: on
 * any Cash surface the feed is provably empty, so the landing renders today's
 * chips byte-identically and nothing new ever hits the wire on the Cash path.
 */
@Injectable({ providedIn: 'root' })
export class CashSuggestionsProvider implements SuggestionsProvider {
	getSuggestions(): Observable<SuggestionFeedResult> {
		return of({ cards: [], digest: [], ttlSeconds: DEFAULT_TTL_SECONDS });
	}

	getWorkEvents(): Observable<WorkEvent[]> {
		return of([]);
	}
}
